import { NEXT_STEP } from "../config";

/**
 * Pure mapping from the server-issued next_step to the flow screen to render.
 * The SPA never decides auth outcomes itself — it only reflects next_step.
 * See spec §16.5.
 */
export const FLOW_SCREEN = {
  AUTHENTICATE: "authenticate",
  ENROLL: "enroll",
  PENDING: "pending",
  UNSUPPORTED: "unsupported",
  ERROR: "error",
};

export function screenForNextStep(nextStep) {
  switch (nextStep) {
    case NEXT_STEP.WEBAUTHN_AUTH:
      return FLOW_SCREEN.AUTHENTICATE;
    case NEXT_STEP.REGISTRATION_REQUIRED:
    case NEXT_STEP.REGISTRATION_READY:
      return FLOW_SCREEN.ENROLL;
    case NEXT_STEP.REGISTRATION_PENDING:
      return FLOW_SCREEN.PENDING;
    default:
      return FLOW_SCREEN.ERROR;
  }
}
